import * as Sentry from "@sentry/vue";
import { AxiosError, InternalAxiosRequestConfig } from "axios";

import { getAuthClient } from "@/modules/authorisation/authClient";
import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";
import { useImpersonateStore } from "@/modules/impersonate/impersonateStore";

export async function onRequestSuccess(config: InternalAxiosRequestConfig) {
  try {
    const authClient = await getAuthClient();
    const token = await authClient.getAccessToken();
    const authorisationStore = useAuthorisationStore();
    const { impersonateId } = useImpersonateStore();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      try {
        await authorisationStore.onTokenUpdate(token);
      } catch (e) {
        Sentry.captureException(e);
      }
    }
    if (impersonateId) {
      config.headers["X-Impersonate"] = impersonateId;
    }
    if (authorisationStore.currentFunderId) {
      config.headers["X-Funder-Id"] = authorisationStore.currentFunderId;
    }
    return config;
  } catch (e) {
    const authClient = await getAuthClient();
    await authClient.login();
    throw e;
  }
}

export function onRequestFailed(error: AxiosError) {
  return Promise.reject(error);
}
